import { stringify } from "query-string";
import * as Cookies from "js-cookie";
import { instance } from "../instance";
import { PATH } from "../../shared/constants";
import { operatorPortalIdTokenHeaders } from "./operatorAdminChat";
import { normalizeOperatorEmail } from "../../utils/operatorEmail";
import { IAxiosError, AddStadiumResult } from "../interfaces";
import { getError } from "../utils";

import { DocumentInput, GetStadiumListAggregatedRequest, StadiumAggregated, StadiumPopulated } from "../../shared/interfaces";

function operatorMutationConfig() {
  const email = normalizeOperatorEmail(Cookies.get("SessionEmailAddress") || "");
  return {
    ...operatorPortalIdTokenHeaders(),
    params: email ? { email } : undefined,
  };
}

interface SeatingConfiguration {
  _id: string;
  name: string;
  stadiumId: string;
}

interface UpdateSeatingConfigRequest {
  seatingConfigurationId: string;
}

export const getStadiumPopulatedListRequest = async (
  request: GetStadiumListAggregatedRequest,
): Promise<StadiumAggregated[]> => {
  const stringified = request.city || request.state ? stringify(request, {
    skipNull: true,
  }) : null;

  try {
    const response = await instance.get<StadiumAggregated[]>(`${PATH.API}/${PATH.STADIUM}/${PATH.POPULATED}?${stringified}`);

    return response.data;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};

export const getStadiumById = async (stadiumId: string): Promise<StadiumPopulated> => {
  try {
    const response = await instance.get<StadiumPopulated>(`${PATH.API}/${PATH.STADIUM}/${stadiumId}`);

    return response.data;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};

export const addStadiumRequest = async (request: FormData): Promise<AddStadiumResult> => {
  try {
    const response = await instance.post<AddStadiumResult>(
      `${PATH.API}/${PATH.OPERATOR}/${PATH.STADIUM}`,
      request,
      operatorMutationConfig(),
    );

    return response.data;
  } catch (err) {
    const { response } = err as IAxiosError;
    console.log("addStadiumRequest: ", err);
    throw new Error(getError(response));
  }
};

export const getStadiumSeatingConfigurations = async (
  stadiumId: string,
): Promise<SeatingConfiguration[]> => {
  try {
    const response = await instance.get<SeatingConfiguration[]>(
      `${PATH.API}/${PATH.STADIUM}/${stadiumId}/${PATH.SEATING_CONFIGURATIONS}`,
    );
    return response.data;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};

export const updateStadiumSeatingConfig = async (
  stadiumId: string,
  configId: string,
): Promise<boolean> => {
  try {
    const response = await instance.post(
      `${PATH.API}/${PATH.STADIUM}/${stadiumId}/${PATH.STADIUM_UPDATE_SEATING_CONFIG}`,
      { seatingConfigurationId: configId },
    );
    return response.data.success;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};

export const updateStadiumRequest = async (
  request: FormData, stadiumId: string,
): Promise<AddStadiumResult> => {
  try {
    const response = await instance.put<AddStadiumResult>(
      `${PATH.API}/${PATH.OPERATOR}/${PATH.STADIUM}/${stadiumId}`,
      request,
      operatorMutationConfig(),
    );

    return response.data;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};

export const deleteStadiumRequest = async (stadiumId: string): Promise<boolean> => {
  try {
    await instance.delete<DocumentInput>(
      `${PATH.API}/${PATH.OPERATOR}/${PATH.STADIUM}/${stadiumId}`,
      operatorMutationConfig(),
    );

    return true;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};
